export default __webpack_public_path__ + "static/media/default-user.e355b759.svg";